import React from "react";
import Login from "../pages/login";
import Disclaimer from "../pages/disclaimer";
import { Navigate } from "react-router-dom";
import FinishQuiz from "../pages/finishQuiz";
import Home from "../pages/home";
import TermsAndConditions from "../pages/termsAndConditions";
import PrivacyPolicy from "../pages/privacyPolicy";
import Location from "../pages/location";
import QuestionsNew from "../pages/questionsNew";
import CookiePolicy from "../pages/cookiePolicy";
import OperatorTerms from "../pages/operatorTerms";
import CreatePassword from "../pages/createPassword";
import ForgotPassword from "../pages/forgotPassword";
import OTPSent from "../pages/otpSent";

const origin = window.location.origin;
export const isAssesmentLink = process.env.REACT_APP_NODE === "staging" ? true : (origin === 'https://assessment.flexgrade.io');

export const routes = isAssesmentLink ? [
  {
    path: "/",
    element: <Navigate to={"/disclaimer"} />,
    title: "Flexgrade - The Flex Workspace Industry’s First-Ever Quality Standardization",
    protectedRoute: false,
  },
  {
    path: "/website-terms",
    element: <TermsAndConditions />,
    title: "Flexgrade | Terms and Conditions",
    protectedRoute: false,
  },
  {
    path: "/cookie-policy",
    element: <CookiePolicy />,
    title: "Flexgrade | Cookie Policy",
    protectedRoute: false,
  },
  {
    path: "/operator-terms",
    element: <OperatorTerms />,
    title: "Flexgrade | Operator Terms",
    protectedRoute: false,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
    title: "Flexgrade | Privacy Policy",
    protectedRoute: false,
  },
  {
    path: "/login",
    element: <Login />,
    title: "Flexgrade | Login",
    protectedRoute: false,
    publicRoute: true
  },
  {
    path: "/create-password",
    element: <CreatePassword />,
    title: "Flexgrade | Create Password",
    protectedRoute: false,
    publicRoute: true
  },
  {
    path: "/reset-password",
    element: <CreatePassword />,
    title: "Flexgrade | Reset Password",
    protectedRoute: false,
    publicRoute: true
  },
  {
    path: "/otp-sent",
    element: <OTPSent />,
    title: "Flexgrade | Reset Password",
    protectedRoute: false,
    publicRoute: true
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
    title: "Flexgrade | Reset Password",
    protectedRoute: false,
    publicRoute: true
  },
  {
    path: "/location",
    element: <Location />,
    title: "Flexgrade | Locations",
    protectedRoute: true
  },
  {
    path: "/questions",
    element: <QuestionsNew />,
    title: "Flexgrade | Questions",
    protectedRoute: true,
  },
  {
    path: "/finish",
    element: <FinishQuiz />,
    title: "Flexgrade | Finish Quiz",
    protectedRoute: true
  },
  {
    path: "/instructions",
    element: <Disclaimer />,
    title: "Flexgrade | Instructions",
    protectedRoute: true
  },
  {
    path: "/disclaimer",
    element: <Disclaimer />,
    title: "Flexgrade | Disclaimer",
    protectedRoute: true
  }
] : [
  {
    path: "/",
    element: <Home /> ,
    title: "Flexgrade - The Flex Workspace Industry’s First-Ever Quality Standardization",
    protectedRoute: false,
  },
  {
    path: "/website-terms",
    element: <TermsAndConditions />,
    title: "Flexgrade | Terms and Conditions",
    protectedRoute: false,
  },
  {
    path: "/cookie-policy",
    element: <CookiePolicy />,
    title: "Flexgrade | Cookie Policy",
    protectedRoute: false,
  },
  {
    path: "/operator-terms",
    element: <OperatorTerms />,
    title: "Flexgrade | Operator Terms",
    protectedRoute: false,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
    title: "Flexgrade | Privacy Policy",
    protectedRoute: false,
  },
];


export const navigateWithParams = (navigate, path, params) => {
  const queryString = new URLSearchParams(params).toString();
  navigate(`${path}?${queryString}`);
};
